<template>
  <el-main>
    <div class="middle">
      <div class="container">
        <div class="report_con">
          <div class="right bg-color home-p-color">
            <h2 class="title">
              {{ blog.title }}
            </h2>
            <p class="date">
              {{ blog.release }}
            </p>
            <div class="line" />
            <div>
              <img
                v-if="blog.show_image"
                class="image"
                :src="blog.image"
                alt=""
              >
              <p class="subtitle">
                {{ blog.subtitle }}
              </p>
              <div
                class="content"
                v-html="blog.content"
              />
              <template v-if="blog.video">
                <video
                  v-if="blog.video.substring(0, 4) === 'http'"
                  id="player"
                  ref="video"
                  autoplay
                  playsinline
                  controls
                  loop
                  style="object-fit: cover;width:100%;"
                >
                  <source
                    :src="blog.video"
                    type="video/mp4"
                  >Your browser does not support the video tag.
                </video>
                <youtube
                  v-else
                  width="842px"
                  height="474px"
                  :video-id="blog.video"
                />
              </template>

              <div
                class="content"
                v-html="blog.second_content"
              />
            </div>
          </div>
          <div class="left">
            <div
              class="left_item bg-color home-color"
              style="font-weight: bold;"
            >
              {{ $t('common.p82') }}
            </div>
            <div
              v-for="(item, index) in popularList"
              :key="index"
              class="left_item bg-color home-p-color"
              @click="updateData(item.id)"
            >
              <div class="item_content">
                <p class="p1">
                  {{ item.title }}
                </p>
                <p class="p2">
                  <span>{{ item.release }}</span>
                </p>
              </div>
            </div>
            <social-sharing
              :title="blog.title"
              :description="blog.subtitle"
              inline-template
            >
              <div class="icon home-p-color">
                <span>{{ $t('common.p105') }}:</span>
                <network network="facebook">
                  <div
                    class="facebook-img icon_img"
                  />
                </network>
                <network network="twitter">
                  <div
                    class="twitter-img icon_img"
                  />
                </network>
                <network network="linkedin">
                  <div
                    class="instagram-img icon_img"
                  />
                </network>
              </div>
            </social-sharing>
          </div>
        </div>
      </div>
    </div>
  </el-main>
</template>

<script>
// @ is an alias to /src
import { getBlogArticle } from '@/api/official'
import Vue from 'vue'
import VueYoutube from 'vue-youtube'
import SocialSharing from 'vue-social-sharing'

Vue.use(VueYoutube)
Vue.use(SocialSharing)

export default {
  data () {
    return {
      blog: {},
      popularList: []
    }
  },
  created () {
    this.$store.commit('changeTab', '/blog')
    this.initData()
    this.initPopular()
  },
  mounted () {
    document.querySelector('#app').scrollIntoView({ block: 'start', behavior: 'smooth' })
  },
  methods: {
    initData () {
      let articleId = this.$route.params.item

      getBlogArticle({ articleId })
        .then(res => {
          this.blog = res.data.list.map(v => {
            return { id: v.id, ...v.article[this.$i18n.locale], image: v.pcImage, release: v.release, show_image: v.show_image }
          })[0]
        })
        .catch(err => {
          console.log(err)
        })
    },
    initPopular () {
      getBlogArticle({ isFavorite: 1 })
        .then(res => {
          this.popularList = res.data.list.map(v => {
            return { id: v.id, ...v.article[this.$i18n.locale], release: v.release }
          })
        })
        .catch(err => {
          console.log(err)
        })
    },
    updateData (articleId) {
      window.open('/blog/' + articleId)
      // this.$router.push({ name: 'blog-item', params: { item: articleId } })
      // this.initData()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.el-main {
  position: relative;
  padding: 0;
  // padding-bottom: 96px;
  min-width: 1200px;
  .middle {
    color: #fff;
    position: relative;
    // background-color: #2a2a2a;
    padding: 65px 0px;
    .report_con {
      display: flex;
      justify-content: space-around;
      align-items: flex-start;
      min-height: 1000px;
      .left {
        position: relative;
        display: inline-block;
        text-align: center;
        .left_item:nth-child(n+2) {
          cursor: pointer;
        }
        .left_item {
          position: relative;
          width: 210px;
          margin-bottom: 1px;
          padding: 15px 15px;
          .item_content {
            position: relative;
            z-index: 1;
          }
          .p1 {
            font-size: 14px;
            text-align: left;
            &:hover {
              color: #1f9d56;
            }
          }
          .p2 {
            font-size: 12px;
            color: #7b7b7b;
            text-align: right;
            margin-top: 2px;
          }
        }
        .highlight {
          background-color: #58b26d;
        }
        .left_item::after {
            position: absolute;
            content: "";
            display: block;
            top: 0px;
            left: 0px;
            width: 0;
            height: 100%;
            background-color: #58b26d;
            transition: all 0.6s ease 0s;
          }
          .left_item:nth-child(n+2):hover::after {
            width: 100%;
          }
          .left_item:hover {
            .p1, .p2 {
              color: #fff;
            }
          }
        .icon {
          display: inline-block;
          margin-top: 20px;
          a {
            margin: 0 10px;
            display: inline-block;
            background-size: 100%;
            background-repeat: no-repeat;
            background-position: center center;
            width: 12px;
            height: 26px;
            vertical-align: middle;
          }
          /deep/.facebook-img {
            background-image: url(/official/static/img/blog/3_facebook_b.svg);
            &:hover {
              background-image: url(/official/static/img/blog/3_facebook_g.svg);
            }
          }
          /deep/.instagram-img {
            background-image: url(/official/static/img/blog/3_linkedIn_b.svg);
            &:hover {
              background-image: url(/official/static/img/blog/3_linkedIn_g.svg);
            }
          }
          /deep/.twitter-img {
            background-image: url(/official/static/img/blog/3_twitter_b.svg);
            background-position: center bottom;
            &:hover {
              background-image: url(/official/static/img/blog/3_twitter_g.svg);
            }
          }
          /deep/span {
            display: block;
            &:focus {
              outline: none;
            }
          }
          /deep/.icon_img {
            margin: 10px 10px;
            display: inline-block;
            cursor: pointer;
            height: 40px;
            width: 40px;
            background-size: 100% auto;
            background-repeat: no-repeat;
          }
        }
      }
      .right {
        position: relative;
        width: 842px;
        display: inline-block;
        // padding: 40px 60px 80px 60px;;
        padding: 52px 44px;
        .title {
          font-size: 32px;
          color: #1f9d56;
          margin: 0px;
          // margin-bottom: 20px;
        }
        .date {
          // color: #9f9f9f;
          font-size: 20px;
        }
        .line {
          border-bottom: 1px solid #bebebe;
          margin: 16px 0px 30px 0px;
        }
        .subtitle {
          font-size: 18px;
          // color: #9fa0a0;
          margin-bottom: 20px;
          margin-top: 10px;
        }
        p {
          font-size: 16px;
          margin: 10px 0px;
          line-height: 24px;
        }
        img {
          width: 100%;
          display: block;
        }
        video {
          margin: 20px 0px;
        }
        .content {
          /deep/img {
            max-width: 100%;
            height: auto;
          }
          /deep/a {
            color: #1f9d56;
          }
          /deep/h2 {
            font-size: 20px;
            margin: 20px 0px 20px 0px;
          }
          /deep/p {
            // color: #9f9f9f;
            font-size: 16px;
            // margin-bottom: 18px;
            line-height: 24px;
          }
        }
      }
    }
  }
}
</style>
